import { DestroyRef, inject, Injectable, signal } from '@angular/core';

const TICK_INTERVAL_MS = 1000;

/**
 * Ticking wall clock for UI bounds that must track the real time, such as the
 * playback pickers whose latest selectable instant is "now".
 */
@Injectable({ providedIn: 'root' })
export class CurrentTimeService {
  private readonly current = signal(new Date());

  readonly now = this.current.asReadonly();

  constructor() {
    const handle = setInterval(() => this.current.set(new Date()), TICK_INTERVAL_MS);
    inject(DestroyRef).onDestroy(() => clearInterval(handle));
  }
}
